import { createRef, h } from "preact";
import { useEffect, useState } from "preact/hooks";

import RadioButtonGroup from "../RadioButtonGroup.jsx";
import i18n from "../../i18n";

function getValue(value) {
  if (value === false || value === "false") {
    return "false";
  }
  if (value === 0) {
    return "0";
  }
  // choices with optional description
  if (Array.isArray(value)) {
    return value[0];
  }
  return (value || "").toString();
}

export default function Choice(props) {
  const [value, setValue] = useState("");

  function handleChange(event) {
    setValue(event.target.value);
  }

  useEffect(() => {
    const chosenChoice = props.options.choices.find(
      ([_label, v]) => getValue(v) === value
    );
    if (chosenChoice) props.onSelect(chosenChoice);
  }, [props.options.choices, value]);

  useEffect(() => {
    const initialChoice = props.options.choices.find(
      ([label, _value]) =>
        getValue(label) ===
        (props.answer
          ? getValue(props.answer)
          : getValue(props.options.initialValue))
    );
    setValue(initialChoice ? initialChoice[1] : props.answer);
  }, [props.options.choices, props.answer, props.options.initialValue]);

  const items = props.options.choices.map(([label, value]) => {
    let description = null;
    if (props.options.choiceOptions) {
      description = i18n.t(
        `questions.${props.dataKey}.choice_options.${getValue(value)}`
      );
    }
    return {
      value: getValue(value),
      description,
      label,
    };
  });

  return (
    <div class="mb-32">
      {props.options.label && (
        <label
          class="block t-body3 color-shades-charcoal"
          for="question-choice"
        >
          {props.options.label}
        </label>
      )}
      <RadioButtonGroup
        boxed
        class={props.options.label ? "mt-48" : "mt-0"}
        id="question-choice"
        name="answer"
        items={items}
        value={getValue(value)}
        onChange={handleChange}
      />
      {props.error && (
        <span class="inlineValidation--failure">{props.error}</span>
      )}
    </div>
  );
}
